export default __webpack_public_path__ + "static/media/Stammdaten.9285b7b2.svg";